import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { AlloyGatorSection } from '../components/AlloyGatorSection';
import { HighlightSection } from '../components/HighlightSection';
import { PortfolioSection } from '../components/PortfolioSection';
import { USPSection } from '../components/USPSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { CTASection } from '../components/CTASection';
import { SEOTextSection } from '../components/SEOTextSection';
import { SEO } from '../components/SEO';
export const HomePage = () => {
  return <main data-id="element-1545" data-mp="36rv9tx239dhc">
      <SEO title="BKCustoms Almere | Ramen Blinderen & Auto Wrappen in Almere" description="Premium auto styling in Almere: ramen blinderen, auto wrappen, lichten smoken en ontchromen. 5,0 uit 72 Google reviews. Elke dag open 09:00-18:00." canonical="/" includeLocalBusiness data-id="element-1546" data-mp="36rn18hd00uby" />
      <HeroSection data-id="element-1547" data-mp="2993ntzyo3cb5" />
      <ServicesSection data-id="element-1548" data-mp="2ap4twk8o7f1f" />
      <PortfolioSection data-id="element-1549" data-mp="2anttmuefopf2" />
      <ReviewsSection data-id="element-1550" data-mp="2aod984gm31px" />
      <AlloyGatorSection data-id="element-1551" data-mp="2an27092te20x" />
      <HighlightSection data-id="element-1552" data-mp="2epyjdi1rh1wf" />
      <USPSection data-id="element-1553" data-mp="2epf3s7zl2plk" />
      <SEOTextSection data-id="element-1554" data-mp="2eongrlk1y06w" />
      <CTASection data-id="element-1555" data-mp="2eo3zm7287ftx" />
    </main>;
};